import { ReactNode } from 'react';

import { cn } from '@/app/shared/lib/cn';

interface ReferralEmptyStateProps {
  title: string;
  description: ReactNode;
  descriptionClassName?: string;
}

const ReferralEmptyState = ({ title, description, descriptionClassName }: ReferralEmptyStateProps) => (
  <div className='flex min-h-76 flex-col items-center justify-center gap-3 rounded-md bg-elevated-card-2 p-4 md:gap-1.5'>
    <span className='leading-5.5 font-medium text-brand-1100'>{title}</span>
    <p className={cn('max-w-md text-center text-sm text-gray-400', descriptionClassName)}>{description}</p>
  </div>
);

export default ReferralEmptyState;
